import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import { formatHeat } from "@/utils/format";

interface RelatedArticlesProps {
  items: Article[];
}

export default function RelatedArticles({ items }: RelatedArticlesProps) {
  if (items.length === 0) return null;

  return (
    <section className="rounded-card border border-background-200/80 bg-background-50 p-5">
      <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-links-line text-primary-500"></i>
        </span>
        延伸阅读
      </h2>
      <ul className="mt-4 flex flex-col gap-3">
        {items.map((item) => (
          <li key={item.slug}>
            <Link
              to={`/article/${item.slug}`}
              className="group flex gap-3 rounded-xl p-2 transition-colors duration-200 hover:bg-primary-50/70"
            >
              <span className="h-16 w-20 shrink-0 overflow-hidden rounded-lg bg-background-200">
                <img
                  src={item.cover}
                  alt={item.coverAlt}
                  title={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="flex min-w-0 flex-1 flex-col justify-between">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors duration-200 group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1">
                    <span className="flex h-3 w-3 items-center justify-center">
                      <i className="ri-fire-line text-[11px] text-primary-400"></i>
                    </span>
                    {formatHeat(item.heat)}
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}